import Subscription from '@/generated/classes/Subscription';
export default class SubscriptionExtend extends Subscription {
  constructor() {
    super();
  }
}
